import { useIntl } from "react-intl";
import DashboardClientLayout from "../../Layouts/DashboardClientLayout";
import "./HomePage.css";

function SlidersIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 7h7M15 7h5M13 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM4 12h4M12 12h8M10 12a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM4 17h10M17 17h3M15 17a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z" />
    </svg>
  );
}

function UserIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="8" r="3" />
      <path d="M4.5 20a7.5 7.5 0 0 1 15 0" />
    </svg>
  );
}

function RouteIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6 6h4a3 3 0 0 1 3 3v0a3 3 0 0 1-3 3H8a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2h10" />
      <path d="M15 18l3-3-3-3" />
    </svg>
  );
}

function CardIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="4" y="6" width="16" height="12" rx="2.5" />
      <path d="M4 10h16" />
    </svg>
  );
}

function GlobeIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="8.5" />
      <path d="M3.7 12h16.6M12 3.5a14 14 0 0 1 0 17M12 3.5a14 14 0 0 0 0 17" />
    </svg>
  );
}

function MoneyIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="8.5" />
      <path d="M10 10.2c0-.9.8-1.7 2-1.7s2 .6 2 .6M10.2 13.8c.3.8 1.1 1.5 2.4 1.5 1.4 0 2.4-.8 2.4-1.9 0-1.2-1.2-1.7-2.4-2-1.2-.4-2.4-.8-2.4-2 0-1.1 1-1.9 2.4-1.9 1 0 1.7.3 2.1.7" />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="4" y="6" width="16" height="12" rx="2.5" />
      <path d="m5.5 8.5 6.5 5 6.5-5" />
    </svg>
  );
}

function CalendarIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="4" y="5" width="16" height="15" rx="2.5" />
      <path d="M8 3.5v3M16 3.5v3M4 10h16" />
    </svg>
  );
}

function BellIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 4a5 5 0 0 0-5 5v2.5c0 .9-.3 2.1-.8 3l-.9 1.5h13.4l-.9-1.5c-.5-.9-.8-2.1-.8-3V9a5 5 0 0 0-5-5Z" />
      <path d="M9.5 19a2.5 2.5 0 0 0 5 0" />
    </svg>
  );
}

function LockIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="5" y="10" width="14" height="10" rx="2.5" />
      <path d="M8 10V8a4 4 0 0 1 8 0v2" />
    </svg>
  );
}

function ShieldIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 3.5 19 6.4v5.2c0 4.4-3 7.8-7 9.4-4-1.6-7-5-7-9.4V6.4L12 3.5Z" />
      <path d="m8.5 12.1 2.4 2.4 4.8-5" />
    </svg>
  );
}

function DataIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4.5 8.5c0 1.9 3.4 3.5 7.5 3.5s7.5-1.6 7.5-3.5S16.1 5 12 5 4.5 6.6 4.5 8.5Z" />
      <path d="M4.5 8.5V12c0 1.9 3.4 3.5 7.5 3.5s7.5-1.6 7.5-3.5V8.5" />
      <path d="M4.5 12v3.5c0 1.9 3.4 3.5 7.5 3.5s7.5-1.6 7.5-3.5V12" />
    </svg>
  );
}

function HelpIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 15.5v.3M9.8 9.8a2.5 2.5 0 1 1 4.4 1.7c-.9.8-1.8 1.2-1.8 2.5" />
    </svg>
  );
}

function LogoutIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M10 4.5H6.8A2.3 2.3 0 0 0 4.5 6.8v10.4a2.3 2.3 0 0 0 2.3 2.3H10" />
      <path d="m13 8 4 4-4 4M17 12H9" />
    </svg>
  );
}

function ChevronIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m9 6 6 6-6 6" />
    </svg>
  );
}

function Switch({ checked = false }) {
  return (
    <span className={`pc-switch ${checked ? "is-on" : ""}`} aria-hidden="true">
      <span className="pc-switch-thumb" />
    </span>
  );
}

function SelectPill({ label }) {
  return (
    <button type="button" className="pc-select-pill">
      <span>{label}</span>
      <ChevronIcon />
    </button>
  );
}

function SectionRow({ icon, title, desc, right = null, showChevron = true }) {
  const Icon = icon;
  return (
    <div className="pc-row">
      <span className="pc-row-icon">
        <Icon />
      </span>
      <div className="pc-row-copy">
        <strong>{title}</strong>
        <span>{desc}</span>
      </div>
      <div className="pc-row-right">
        {right}
        {showChevron ? <ChevronIcon /> : null}
      </div>
    </div>
  );
}

function ToggleRow({ icon, title, desc, checked }) {
  const Icon = icon;
  return (
    <div className="pc-row">
      <span className="pc-row-icon">
        <Icon />
      </span>
      <div className="pc-row-copy">
        <strong>{title}</strong>
        <span>{desc}</span>
      </div>
      <div className="pc-row-right">
        <Switch checked={checked} />
      </div>
    </div>
  );
}

function CardSection({ title, icon, children }) {
  const Icon = icon;
  return (
    <article className="pc-card">
      <div className="pc-card-title">
        <span className="pc-card-title-icon">
          <Icon />
        </span>
        <h3>{title}</h3>
      </div>
      <div className="pc-card-body">{children}</div>
    </article>
  );
}

export default function ParametreClient() {
  const intl = useIntl();

  return (
    <>
      <div className="pc-hero">
        <h1>{intl.formatMessage({ id: "dashboard.settings.page.title" })}</h1>
        <p>{intl.formatMessage({ id: "dashboard.settings.page.subtitle" })}</p>
      </div>

      <div className="pc-settings-layout">
        <section className="pc-settings-main">
          <CardSection title={intl.formatMessage({ id: "dashboard.settings.general.title" })} icon={SlidersIcon}>
            <SectionRow
              icon={UserIcon}
              title={intl.formatMessage({ id: "dashboard.settings.general.accountInfo.title" })}
              desc={intl.formatMessage({ id: "dashboard.settings.general.accountInfo.desc" })}
            />
            <SectionRow
              icon={RouteIcon}
              title={intl.formatMessage({ id: "dashboard.settings.general.ridePrefs.title" })}
              desc={intl.formatMessage({ id: "dashboard.settings.general.ridePrefs.desc" })}
            />
            <SectionRow
              icon={CardIcon}
              title={intl.formatMessage({ id: "dashboard.settings.general.paymentMethods.title" })}
              desc={intl.formatMessage({ id: "dashboard.settings.general.paymentMethods.desc" })}
            />
            <SectionRow
              icon={GlobeIcon}
              title={intl.formatMessage({ id: "dashboard.settings.general.language.title" })}
              desc={intl.formatMessage({ id: "dashboard.settings.general.language.desc" })}
              right={<SelectPill label={intl.formatMessage({ id: "dashboard.settings.general.language.value" })} />}
              showChevron={false}
            />
            <SectionRow
              icon={MoneyIcon}
              title={intl.formatMessage({ id: "dashboard.settings.general.currency.title" })}
              desc={intl.formatMessage({ id: "dashboard.settings.general.currency.desc" })}
              right={<SelectPill label={intl.formatMessage({ id: "dashboard.settings.general.currency.value" })} />}
              showChevron={false}
            />
          </CardSection>

          <CardSection title={intl.formatMessage({ id: "dashboard.settings.notifications.title" })} icon={BellIcon}>
            <ToggleRow
              icon={BellIcon}
              title={intl.formatMessage({ id: "dashboard.settings.notifications.push.title" })}
              desc={intl.formatMessage({ id: "dashboard.settings.notifications.push.desc" })}
              checked
            />
            <ToggleRow
              icon={MailIcon}
              title={intl.formatMessage({ id: "dashboard.settings.notifications.promoEmails.title" })}
              desc={intl.formatMessage({ id: "dashboard.settings.notifications.promoEmails.desc" })}
              checked
            />
            <ToggleRow
              icon={CalendarIcon}
              title={intl.formatMessage({ id: "dashboard.settings.notifications.dailySummary.title" })}
              desc={intl.formatMessage({ id: "dashboard.settings.notifications.dailySummary.desc" })}
              checked={false}
            />
            <ToggleRow
              icon={BellIcon}
              title={intl.formatMessage({ id: "dashboard.settings.notifications.rideAlerts.title" })}
              desc={intl.formatMessage({ id: "dashboard.settings.notifications.rideAlerts.desc" })}
              checked
            />
          </CardSection>
        </section>

        <aside className="pc-settings-sidebar">
          <CardSection title={intl.formatMessage({ id: "dashboard.settings.security.title" })} icon={ShieldIcon}>
            <SectionRow
              icon={LockIcon}
              title={intl.formatMessage({ id: "dashboard.settings.security.password.title" })}
              desc={intl.formatMessage({ id: "dashboard.settings.security.password.desc" })}
            />
            <SectionRow
              icon={ShieldIcon}
              title={intl.formatMessage({ id: "dashboard.settings.security.twoFactor.title" })}
              desc={intl.formatMessage({ id: "dashboard.settings.security.twoFactor.desc" })}
              right={<span className="pc-status-green">{intl.formatMessage({ id: "dashboard.settings.security.twoFactor.status" })}</span>}
            />
            <SectionRow
              icon={DataIcon}
              title={intl.formatMessage({ id: "dashboard.settings.security.activeSessions.title" })}
              desc={intl.formatMessage({ id: "dashboard.settings.security.activeSessions.desc" })}
            />
          </CardSection>

          <CardSection title={intl.formatMessage({ id: "dashboard.settings.privacy.title" })} icon={LockIcon}>
            <SectionRow
              icon={DataIcon}
              title={intl.formatMessage({ id: "dashboard.settings.privacy.personalData.title" })}
              desc={intl.formatMessage({ id: "dashboard.settings.privacy.personalData.desc" })}
            />
            <SectionRow
              icon={ShieldIcon}
              title={intl.formatMessage({ id: "dashboard.settings.privacy.permissions.title" })}
              desc={intl.formatMessage({ id: "dashboard.settings.privacy.permissions.desc" })}
            />
            <SectionRow
              icon={DataIcon}
              title={intl.formatMessage({ id: "dashboard.settings.privacy.activityHistory.title" })}
              desc={intl.formatMessage({ id: "dashboard.settings.privacy.activityHistory.desc" })}
            />
          </CardSection>

          <CardSection title={intl.formatMessage({ id: "dashboard.settings.other.title" })} icon={BellIcon}>
            <SectionRow
              icon={HelpIcon}
              title={intl.formatMessage({ id: "dashboard.settings.other.helpCenter.title" })}
              desc={intl.formatMessage({ id: "dashboard.settings.other.helpCenter.desc" })}
            />
            <SectionRow
              icon={DataIcon}
              title={intl.formatMessage({ id: "dashboard.settings.other.terms.title" })}
              desc={intl.formatMessage({ id: "dashboard.settings.other.terms.desc" })}
            />
            <SectionRow
              icon={UserIcon}
              title={intl.formatMessage({ id: "dashboard.settings.other.about.title" })}
              desc={intl.formatMessage({ id: "dashboard.settings.other.about.desc" })}
            />
            <button type="button" className="pc-logout-action">
              <LogoutIcon />
              <span>{intl.formatMessage({ id: "dashboard.settings.other.logout" })}</span>
            </button>
          </CardSection>
        </aside>
      </div>
    </>
  );
}